'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

require('../util/validators/password-validator.js');
require('../util/helpers/strings.js');
require('../util/helpers/date.js');
require('../util/helpers/arrays.js');
require('../util/helpers/language.js');
require('../util/helpers/numbers.js');
var vuePropertyDecorator = require('vue-property-decorator');
require('../util/helpers/currency.js');
require('../util/helpers/dom.js');
require('../util/helpers/debounce.js');
require('../util/helpers/throttle.js');
require('../util/helpers/functions.js');
var magicSdk = require('@gig/magic-sdk');
var session = require('../util/helpers/session.js');
require('../util/helpers/forms.js');
require('../util/helpers/keys.js');
require('../util/helpers/game.js');
require('../util/helpers/game-category.js');
require('../util/helpers/script.js');
require('../util/helpers/events.js');
require('../util/helpers/password.js');
require('../util/helpers/storage.js');
require('../util/helpers/theming.js');
require('../util/helpers/objects.js');
require('../util/helpers/slots.js');
require('../util/helpers/phone.js');
require('../util/validators/date-validator.js');
require('../util/validators/debounce-validator.js');
require('../util/types/input.js');
require('../util/types/device.enum.js');

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
exports.SessionMixin = class extends vuePropertyDecorator.Vue {
  constructor() {
    super(...arguments);
    this.isLoggedIn = false;
    this.user = null;
  }
  created() {
    magicSdk.magic.events.userUpdated(() => {
      this.user = __spreadValues({}, magicSdk.magic.session.getUser());
    });
  }
  onSessionChange(isLoggedIn) {
    this.isLoggedIn = isLoggedIn;
    this.user = isLoggedIn ? magicSdk.magic.session.getUser() : null;
  }
};
__decorateClass([
  session.SessionChange({ immediate: true })
], exports.SessionMixin.prototype, "onSessionChange", 1);
exports.SessionMixin = __decorateClass([
  vuePropertyDecorator.Component
], exports.SessionMixin);
